import { render, staticRenderFns } from "./MeasurementItems.vue?vue&type=template&id=c2e0a32a&"
import script from "./MeasurementItems.vue?vue&type=script&lang=js&"
export * from "./MeasurementItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports